import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import AvailableTooltip from './AvailableTooltip'

interface Props {
  allowance: Allowance
  currentStat: AllowanceStat
  currentCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const AvailableDays = ({ allowance, currentStat, currentCycle, nextCycle }: Props) => {
  const stat = currentStat.toJS()
  const usedDays = stat.used_days
  const availableDays = stat.available_days
  let proratedDays = stat.prorated_allowance_days

  const totalAdjustment = stat.incidences
  const totalCarryover = stat.accumulated_carry_over
  const advance = availableDays < 0 ? availableDays : 0

  if (usedDays > proratedDays) {
    proratedDays = availableDays > 0 ? availableDays : 0
  }

  const title = allowance.isDays
    ? i18n.t('time_off.available_tooltip.available_days')
    : i18n.t('time_off.available_tooltip.available_hours')

  return (
    <>
      <Box flexDirection="row" gap="s8" paddingY="s16">
        <Text size="700" weight="medium">
          {i18n.formatNumber(availableDays)}
        </Text>
        <AvailableTooltip
          accrued={proratedDays}
          allowance={allowance}
          carryOver={totalCarryover}
          incidence={totalAdjustment}
          currentCycle={currentCycle}
          nextCycle={nextCycle}
          advance={advance}
        />
      </Box>
      <Box>
        <Text.Header3>{title}</Text.Header3>
      </Box>
    </>
  )
}

export default observer(AvailableDays)
